import Swiper from "swiper";
import { EffectFade, Autoplay } from 'swiper/modules';

// slider on landingPage
const homeCarousel = document.querySelector('.prizes__carousel');
if (!!homeCarousel) {
    const swiper = new Swiper(homeCarousel, {
        modules: [EffectFade,Autoplay],
        direction: "horizontal",
        centeredSlides: true,
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        speed: 600,
        autoplay: true,
        delay: 5000,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        }
    });
}
